<template>
  <div class="container">
    <h4>Kunden-Zusatzinfos</h4>
    <div role="toolbar" class="btn-toolbar justify-content-between">
      <div class="btn-group">
        <button class="btn btn-secondary" @click="prevPage()" id="prev"><font-awesome-icon icon="chevron-left"/></button>
        <button class="btn btn-secondary" @click="nextPage()" id="next"><font-awesome-icon icon="chevron-right"/></button>
      </div>
    </div>
    <b-table class="mt-3" striped hover :fields="fields" :items="rows">
    </b-table>
  </div>
</template>

<script>
import customers from '@/modules/customers.js'

export default {
  props:['customer'],
  data() {
    return {
      start: 0,
      count: 40,
      sort: 'map_id',
      rows: [],
      fields: [
        {label:"ID",          key:"map_id"},
        {label:"Inhalt",      key:"content"},
        {label:"Typ",         key:"type"},
        {label:"Resource",    key:"ref_id"},
        {label:"Verknüpfung", key:"sub_ref"},
      ]
    }
  },
  mounted: function() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      var self = this;
      console.log('read extras for customer: ' + this.customer);
      customers.listextras(this,this.customer,this.start,this.count,this.sort,function(data) {
        console.log(data);
        self.rows = data;
      })
    },
    nextPage() {
      this.start += this.count;
      this.fetchData();
    },
    prevPage() {
      if (this.start >= this.count) {
        this.start -= this.count;
        this.fetchData();
      }
    },
    updateSort() {

    }
  }
}
</script>
